/**
 * @desc 获取银行信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BankInfoResponse>>;
export function request(body: defs.basics.BankInfoRequest, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getBankInfoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
